<template>
	<ViewWrapper>
		<div cols="12" class="w-100 h-100 d-flex flex-row justify-center align-center">
			<v-container>
				<v-row justify="center" align="center">
					<v-col cols="12" md="8" sm="6" class="d-flex justify-center px-md-15">
						<img src="@/assets/dashboard.png" width="100%" />
					</v-col>
					<v-col cols="12" md="4" sm="6">
						<v-row align="center">
							<v-col v-if="usuarioPossuiPermissao(usuarioLogado, PERMISSOES_FGTAS.CADASTRAR_VAGA)" cols="12">
								<v-btn class="w-100" height="70px" color="primary" @click="router.push('/vagas/nova')">
									CADASTRO DE VAGAS
								</v-btn>
							</v-col>
							<v-col v-if="usuarioPossuiPermissao(usuarioLogado, PERMISSOES_FGTAS.ACOMPANHAR_VAGA)" cols="12">
								<v-btn class="w-100" height="70px" color="primary" @click="router.push('/vagas/lista')">
									ACOMPANHAR VAGAS
								</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
		</div>
	</ViewWrapper>
</template>

<script setup>
import ViewWrapper from "@/components/commons/wrapper/ViewWrapper.vue";
import router from "@/router/router";
import store from '@/store';
import { computed } from "vue";
import { PERMISSOES_FGTAS, usuarioPossuiPermissao } from "@/utils/PermissaoUtils.js";

const usuarioLogado = computed(() => store.getters["usuario/getUsuarioLogado"]);
</script>
